$(function ()
{
	if (typeof FroalaEditor == "undefined") {
		return;
	}
	
	FroalaEditor.VIDEO_PROVIDERS.push(
		{
			html: '{url}',
			provider: 'wistia',
			test_regex: /^.*wistia.com\/medias\/.*/,
			url_regex: /^.*wistia.com\/medias\/(.*)$/,
			url_text:
				'<span class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">' +
				'<span class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">' +
				'<iframe src="https://fast.wistia.net/embed/iframe/$1?videoFoam=true" title="We Can Be Active video" allow="autoplay; fullscreen" allowtransparency="true" frameborder="0" ' +
				'scrolling="no" class="wistia_embed" name="wistia_embed" allowfullscreen msallowfullscreen width="100%" height="100%"></iframe>' +
				'</span></span><script src="https://fast.wistia.net/assets/external/E-v1.js" async></script>'
		}
	);

});